export function firstApiErrorMessage(error) {
  const errors =
    error && error.response && error.response.data && error.response.data.errors

  if (errors && typeof errors === "object") {
    const message =
      errors.registration_date || errors.base || Object.values(errors)[0]

    if (Array.isArray(message)) {
      return message[0]
    }

    if (typeof message === "string") {
      return message
    }
  }

  return null
}

const routeTemplate = (url) =>
  new URL(url, "http://api").pathname
    .split("/")
    .filter(Boolean)
    .map((segment) => (/\d/.test(segment) ? ":id" : segment))
    .join("/")

export function describeHttpError(event, error) {
  if (!error || !error.isAxiosError) return event

  const status = error.response ? error.response.status : "network error"
  const data = error.response?.data
  const code = data?.code || data?.errors?.[0]?.code
  if (status === 401 || code === "email_required") return null

  const route = `/${routeTemplate(error.config.url)}`
  const method = error.config.method.toUpperCase()
  const title = [`${method} ${route} → ${status}`, code].filter(Boolean).join(" ")
  const exception = event.exception?.values?.[0]

  if (exception) exception.value = title
  event.fingerprint = ["http", title]
  event.tags = { ...event.tags, api_route: route, api_status: String(status) }
  if (code) event.tags.api_error_code = code
  return event
}
